import { useRef, useState } from 'react'

export function useSteps<T>(initial: T): {
	setCurrentStep: (t: T) => void
	currentStep: T
	goBack?: () => void
} {
	const [step, setStep] = useState<T>(initial)
	const steps = useRef<T[]>([step])

	const setCurrentStep = (t: T): void => {
		steps.current.push(t)
		setStep(t)
	}
	const goBack =
		steps.current.length > 1
			? () => {
					steps.current.pop()
					const [previous] = steps.current.slice(-1)
					previous && setStep(previous)
			  }
			: undefined
	return { currentStep: step, setCurrentStep, goBack }
}
